import React from 'react'
import { Link } from 'gatsby'

import './index.scss'

export const CategoryNavigator = ({ name, href }) => {
  return (
    <Link to={href} rel="tag" className="category-navigator">
      <span><strong><u>📁 Category</u></strong></span>
      <span>{name}</span>
    </Link>
  )
}
